import { render, staticRenderFns } from "./MaskSettingsModal.vue?vue&type=template&id=2ae249ff"
import script from "./MaskSettingsModal.vue?vue&type=script&lang=js"
export * from "./MaskSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./MaskSettingsModal.vue?vue&type=style&index=0&id=2ae249ff&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae249ff')) {
      api.createRecord('2ae249ff', component.options)
    } else {
      api.reload('2ae249ff', component.options)
    }
    module.hot.accept("./MaskSettingsModal.vue?vue&type=template&id=2ae249ff", function () {
      api.rerender('2ae249ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/MaskSettingsModal.vue"
export default component.exports